import Image from "next/image";
import DateFormater from "../blogComponents/date-formater";
import styles from "./articleBody.module.scss";
import { useState, useEffect } from "react";

import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
} from "react-share";
const ArticleBody = ({ date, author, post }) => {
  const [copied, setCopied] = useState(false);
  function copyUrl() {
    const el = document.createElement("input");
    el.value = window.location.href;
    document.body.appendChild(el);
    el.select();
    document.execCommand("copy");
    setCopied(true);
    document.body.removeChild(el);
  }
  return (
    <article className={styles.main}>
      {/* <div className={styles.authorInfos}>
				<div className={styles.left}>
					<Image
						src={author.picture}
						width='40px'
						height='40px'
						className={styles.profilePic}
					/>
					<div className={styles.nameAndDate}>
						<span> By {author.name} </span>
						<br />
						<DateFormater dateString={date && date} />
					</div>
				</div>
				<div className={styles.right}>
					<div className={styles.socialsIcon}>
						<FacebookShareButton
							url={`https://coverclap.com/blog/${post.slug}`}
							quote={`${post.title}`}
						>
							<img src='/fb.svg' alt='social icon' />
						</FacebookShareButton>
					</div>
					<div className={styles.socialsIcon}>
						<TwitterShareButton
							url={`https://coverclap.com/blog/${post.slug}`}
							quote={`${post.title}`}
						>
							<img src='/twiiter.svg' alt='social icon' />
						</TwitterShareButton>
					</div>
					{copied ? (
						<span>copied!</span>
					) : (
						<div onClick={() => copyUrl()} className={styles.socialsIcon}>
							<img src='/in.svg' alt='social icon' />
						</div>
					)}
				</div>
			</div> */}
      <div
        className={styles.articlecontent}
        dangerouslySetInnerHTML={{ __html: post.content }}
      ></div>
      {/* <div className={styles.fotter}>
        <div className={styles.socialsIcon}>
          <FacebookShareButton
            url={`https://coverclap.com/blog/${post.slug}`}
            quote={`${post.title}`}
          >
            <img src="/fb.svg" alt="social icon" />
          </FacebookShareButton>
        </div>
        <div className={styles.socialsIcon}>
          <TwitterShareButton
            url={`https://coverclap.com/blog/${post.slug}`}
            quote={`${post.title}`}
          >
            <img src="/twiiter.svg" alt="social icon" />
          </TwitterShareButton>
        </div>
        <div className={styles.socialsIcon}>
          <img src="/in.svg" alt="social icon" />
        </div>
      </div> */}
    </article>
  );
};

export default ArticleBody;
